import React, { Component } from 'react';
import { Link  } from "react-router-dom";

class Header extends Component {
    render() { 
        return ( 
            <header>
                <h1 className="app-name">Typing master</h1>
                <nav>
                <Link className="navlink" to="/start" >Start</Link>
                <Link className="navlink" to="/" >Back</Link>
                </nav>
            </header>
         );
    }
}
 
export default Header;